"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStyleProvider = withStyleProvider;
var _styles = require("@material-ui/core/styles");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var generateClassName = (0, _styles.createGenerateClassName)({
  productionPrefix: "liveview-module-css-",
  // 원하는 프리픽스를 설정
  seed: "liveview-module"
});
function withStyleProvider(WrappedComponent) {
  return function (props) {
    // 스타일이나 테마 관련 로직이 여기 들어갈 수 있습니다.
    return (
      /*#__PURE__*/
      //@ts-ignore
      _react["default"].createElement(_styles.StylesProvider, {
        generateClassName: generateClassName
      }, /*#__PURE__*/_react["default"].createElement(WrappedComponent, props))
    );
  };
}